<template>
  <!-- About seville for phones -->
  <section id="about-seville">
    <!-- About seville Text -->
    <v-flex pt-2 xs12>
      <v-layout row>
        <v-flex xs12 sm6 offset-sm3>
          <v-expansion-panel id="about-sevilla-mobile-collapse" flat class="elevation-0">
            <v-expansion-panel-content class="about-sevilla-mobile-collapse-content" flat>
              <template v-slot:header>
                <div class="golden_color title font-weight-bold">{{getTranslation('why-sevilla')}}</div>
              </template>
              <v-card class="about-sevilla-mobile-collapse-content">
                <v-img src="/static/custom-images/plaza-españa.jpg" aspect-ratio="2.75"></v-img>
                <v-card-text v-html="getTranslation('why-sevilla-desc')"></v-card-text>
              </v-card>
            </v-expansion-panel-content>

            <v-expansion-panel-content class="about-sevilla-mobile-collapse-content" flat>
              <template v-slot:header>
                <div class="golden_color title font-weight-bold">{{getTranslation('monuments')}}</div>
              </template>
              <v-card class="about-sevilla-mobile-collapse-content">
                <v-img src="/static/custom-images/giralda.jpg" aspect-ratio="2.75"></v-img>
                <v-card-text v-html="getTranslation('monuments-desc')"></v-card-text>
              </v-card>
            </v-expansion-panel-content>

            <v-expansion-panel-content class="about-sevilla-mobile-collapse-content" flat>
              <template v-slot:header>
                <div class="golden_color title font-weight-bold">{{getTranslation('museums')}}</div>
              </template>
              <v-card class="about-sevilla-mobile-collapse-content">
                <v-img src="/static/custom-images/museos.jpg" aspect-ratio="2.75"></v-img>
                <v-card-text v-html="getTranslation('museums-desc')"></v-card-text>
              </v-card>
            </v-expansion-panel-content>

            <v-expansion-panel-content class="about-sevilla-mobile-collapse-content" flat>
              <template v-slot:header>
                <div class="golden_color title font-weight-bold">{{getTranslation('flamenco')}}</div>
              </template>
              <v-card class="about-sevilla-mobile-collapse-content">
                <v-img src="/static/custom-images/flamenco.jpg" aspect-ratio="2.75"></v-img>
                <v-card-text v-html="getTranslation('flamenco-desc')"></v-card-text>
                <v-img src="/static/custom-images/setas.jpg" aspect-ratio="2.75"></v-img>
                <v-card-text v-html="getTranslation('setas-desc')"></v-card-text>
              </v-card>
            </v-expansion-panel-content>

            <v-expansion-panel-content class="about-sevilla-mobile-collapse-content" flat>
              <template v-slot:header>
                <div class="golden_color title font-weight-bold">{{getTranslation('only-sevilla')}}</div>
              </template>
              <v-card class="about-sevilla-mobile-collapse-content">
                <v-img src="/static/custom-images/star-wars.jpg" aspect-ratio="2.75"></v-img>
                <v-card-text v-html="getTranslation('only-sevilla-desc')"></v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-flex>
      </v-layout>
    </v-flex>
  </section>
</template>

<script>
export default {
  props: ["restaurant"],
  name: "aboutSevilla",
  methods: {
    // Get translation must be first if used in other methods
    getTranslation(key) {
      return this.$t(key);
    }
  }
};
</script>

<style scoped>
@import "custom_styles.css";
#about-sevilla-mobile-collapse {
  background-color: transparent !important;
}

.about-sevilla-mobile-collapse-content {
  background-color: transparent !important;
  border: none !important;
}

#about-seville {
  margin-bottom: 10%;
}
</style>


// WEBPACK FOOTER //
// src/components/AboutSevilla.vue